/*
 * @Author: your name
 * @Date: 2021-07-09 17:37:35
 * @LastEditTime: 2021-07-21 15:38:59
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \contingency-manage\src\components\global\index.js
 */
const contexts = require.context('.', false, /\.vue$/);
const global = (app) => {
  contexts.keys().forEach(component => {
    const componentEntity = contexts(component).default;
    // 使用内置的组件名称 进行全局组件注册
    app.component(componentEntity.name, componentEntity);
  });
};
export default global;